import { initContract } from "@ts-rest/core";
import { z } from "zod";
import { Taxonomy } from "@common/categories";
import { ErrorMessageSchema } from "@common/schemas/error.schema";
import {
    categoryCoaMappingSchema,
    categoryCoaMappingsResponseSchema,
    updateCategoryCoaMappingBodySchema,
} from "@common/schemas/domains/accounting/categoryCoaMapping.schema";

const c = initContract();

/**
 * Per-entity mapping of Kick category taxonomies to the accounts of the
 * entity's custom chart of accounts.
 */
export const categoryCoaMappingContract = c.router(
    {
        getMappings: {
            method: "GET",
            path: "/:entityId",
            pathParams: z.object({
                entityId: z.coerce.number(),
            }),
            responses: {
                200: categoryCoaMappingsResponseSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
        updateMapping: {
            method: "PUT",
            path: "/:entityId/:taxonomy",
            pathParams: z.object({
                entityId: z.coerce.number(),
                taxonomy: z.nativeEnum(Taxonomy),
            }),
            body: updateCategoryCoaMappingBodySchema,
            responses: {
                200: categoryCoaMappingSchema,
                400: ErrorMessageSchema,
                403: ErrorMessageSchema,
                404: ErrorMessageSchema,
            },
        },
    },
    { pathPrefix: "/category-coa-mapping" },
);
